export const E_BIDS_READY = 'PomadBidsReady';
export const E_DFP_AD_RENDERED = 'PomadAdRendered';

